import { render, staticRenderFns } from "./ConsignmentRegistrationForm.vue?vue&type=template&id=588b3562&"
import script from "./ConsignmentRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ConsignmentRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports